import { Injectable } from '@angular/core';
import { GoogleRecaptchaService } from '@df/module-google-recaptcha/google-recaptcha.service';

@Injectable({
    providedIn: 'root'
})
export class GoogleRecaptchaServiceDecorator extends GoogleRecaptchaService {
    protected override get key(): string | undefined {
        return this.app.data.customform?.captcha?.key || super.key;
    }
}
